import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

const CenteredBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
});

export default CenteredBox;
